import { render, staticRenderFns } from "./ModalClas.vue?vue&type=template&id=3c2c0375&"
import script from "./ModalClas.vue?vue&type=script&lang=js&"
export * from "./ModalClas.vue?vue&type=script&lang=js&"
import style0 from "./ModalClas.vue?vue&type=style&index=0&id=3c2c0375&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports